import React from 'react';

/**
 * Wrapper component that conditionally renders sections based on visibility settings
 * @param {string} sectionType - The type of section (e.g., 'hero', 'why-choose')
 * @param {array} sections - Array of section configurations from database
 * @param {boolean} sectionsLoading - Loading state for sections
 * @param {node} children - The section content to render
 */
const SectionWrapper = ({ sectionType, sections, sectionsLoading, children }) => {
  // Hero section should always be visible (critical section)
  if (sectionType === 'hero') {
    return <>{children}</>;
  }

  // While loading sections config, show all sections (default behavior)
  if (sectionsLoading || !sections || sections.length === 0) {
    return <>{children}</>;
  }

  // Find this section in the config
  const sectionConfig = sections.find(s => s.type === sectionType);
  
  // If section not found in config, show it anyway (backwards compatibility)
  if (!sectionConfig) {
    return <>{children}</>;
  }

  // Check visibility
  if (!sectionConfig.is_visible) {
    return null; // Don't render hidden sections
  }

  // Render visible section
  return <>{children}</>;
};

export default SectionWrapper;
